// src/App.js
import PaymentPage from "./PaymentPage";

function App() {
  return (
    <div>
      <PaymentPage />
    </div>
  );
}

export default App;
